module.exports = "\n<div class=\"comp-cookie-accept\" v-if=\"visible\">\n  <div class=\"container\">\n    <div class=\"row\">\n      <div class=\"col-xs-10\">\n        <p v-t=\"'cookie_accept.message'\"></p>\n      </div>\n      <div class=\"col-xs-2 text-right\"><a class=\"accept\" href=\"#\" v-on:click.prevent=\"onClickOk\" v-t=\"'cookie_accept.button'\"></a></div>\n    </div>\n  </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./assets/js/frontend/components/cookie_accept/index.pug
// module id = 652
// module chunks = 4